












































































































































































































import {Component, Vue, Watch} from 'vue-property-decorator';
import {譲渡確認消費税型, 譲渡金額算出依頼型, 譲渡金額算出結果型, 譲渡入力バリデータマップ一覧} from '@/type/stock/devolve/input/item';
import {
  日付型,
  譲渡検索条件型,
  譲渡削除依頼型,
  譲渡修正依頼型,
  譲渡修正型,
  譲渡検索条件バリデータ一覧,
  修正前譲渡型,
  譲渡修正検索結果型,
} from '@/type/stock/devolve/modification/item';
import api from '@/infrastructure/api/api';
import {ValidationResult} from '@/type/validation/result';
import moment from 'moment';
import {progress} from '@/script/progress';

import Datepicker from '@/components/datepicker/DatePicker.vue';
import ButtonPanel from '@/components/menu/panel/ButtonPanel.vue';
import IconButton from '@/components/atom/button/IconButton.vue';
import NormalButton from '@/components/atom/button/NormalButton.vue';
import AlertDialog from '@/components/atom/dialog/AlertDialog.vue';
import ConfirmDialog from '@/components/atom/dialog/ConfirmDialog.vue';
import DepartmentSelector from '@/components/department/DepartmentSelector.vue';
import TransferMedicalSelector from '@/components/transfermedical/TransferMedicalSelector.vue';
import {loginModule} from '@/store/authentication/login';
import AmountField from '@/components/atom/input/AmountField.vue';
import StockUserSelector from '@/views/stock/StockUserSelector.vue';
import ToggleButtonField from '@/views/stock/StockToggleButtonField.vue';
import {viewEditingStateModule} from '@/store/state/viewEditingState';

@Component({
  components: {
    Datepicker,
    ButtonPanel,
    IconButton,
    NormalButton,
    AlertDialog,
    ConfirmDialog,
    DepartmentSelector,
    TransferMedicalSelector,
    AmountField,
    StockUserSelector,
    ToggleButtonField,
  },
})
export default class DevolveModification extends Vue {

  private itemModal: boolean = false;
  private 譲渡確認消費税: 譲渡確認消費税型 | null = null;
  private 譲渡取込結果: 譲渡修正型[] = [];
  private 譲渡削除対象: 譲渡修正型 | null = null;
  private 譲渡金額算出対象: 譲渡修正型 | null = null;
  private 選択中譲渡先部署コード: string = loginModule.部署コードを取得する;
  private 譲渡先部署コード: string = '';
  private 譲渡検索条件: 譲渡検索条件型 = this.検索条件初期値を取得();
  private 譲渡担当薬剤師: string = '';

  // バリデーション用フィールド
  private 検索条件バリデーション結果: ValidationResult = new ValidationResult(譲渡検索条件バリデータ一覧);
  private 譲渡修正バリデーション結果: ValidationResult = new ValidationResult(譲渡入力バリデータマップ一覧);

  private アラートメッセージ: string | string[] | null = null;

  private 選択中の行index: number|null = null;

  public mounted() {
    if (this.利用ユーザーである()) {
      this.部署を確定する();
    }
    this.消費税取得ハンドラ();
  }

  public beforeUpdate() {
    // データ更新時にバリデート処理
    this.検索条件バリデーション結果.validate(this.譲渡検索条件);
    this.譲渡修正バリデーション結果.validateList(this.譲渡取込結果);
  }

  @Watch('譲渡取込結果', {deep: true})
  private リストが変更された() {
    viewEditingStateModule.画面の編集を開始する();
  }

  private 検索条件エラー判定(項目名: string): boolean {
    return this.検索条件バリデーション結果.hasError(項目名);
  }

  private created(): void {
    moment.locale('ja');
  }

  private 部署を確定する() {
    if (this.選択中譲渡先部署コード === null) {
      this.アラートメッセージ = '部署を選択してください';
      this.ダイアログを開く('アラート');
      return;
    }
    this.譲渡先部署コード = this.選択中譲渡先部署コード;
  }

  private マスターである(): boolean {
    return loginModule.マスターである;
  }

  private 利用ユーザーである(): boolean {
    return !loginModule.管理者である;
  }

  private バラ管理である(): boolean {
    return loginModule.バラ管理である;
  }

  private 部署確定済(): boolean {
    return this.譲渡先部署コード !== '';
  }

  private ダイアログを開く(name: string): void {
    this.$modal.show(name);
  }

  private ダイアログを閉じる(name: string): void {
    this.$modal.hide(name);
  }

  private クリアメッセージ(): string {
    if (viewEditingStateModule.画面を編集中である) {
      return '編集中のデータは破棄されますが、よろしいですか？';
    }
    return 'クリアしますか？';
  }

  private async クリアするハンドラ() {
    await this.クリアする()
            .then((response: any) => {
              viewEditingStateModule.画面の編集を終了する();
            }).catch((error: any) => {
              return;
            });
  }

  private async クリアする(): Promise<void> {
    this.譲渡取込結果 = [];
    this.譲渡削除対象 = null;
    this.譲渡金額算出対象 = null;
    this.選択中の行index = null;
    this.譲渡検索条件 = this.検索条件初期値を取得();
    this.譲渡担当薬剤師 = '';

    this.選択中譲渡先部署コード = loginModule.部署コードを取得する;
    if (!this.利用ユーザーである()) {
        this.譲渡先部署コード = '';
    }

    this.ダイアログを閉じる('クリアダイアログ');
  }

  private 部署未確定(): boolean {
    return !this.部署確定済();
  }

  private 検索条件初期値を取得(): 譲渡検索条件型 {
    return {
      部署コード: '',
      譲渡日付FROM: moment().startOf('month').toDate(),
      譲渡日付TO: null,
      メーカー名: '',
      商品名カナ: '',
      譲渡医療機関コード: null,
      伝票番号: '',
      登録者コード: loginModule.管理者である ? '' : loginModule.利用者コードを取得する,
    };
  }

  private APIアラートダイアログを開く(data: any) {
    this.アラートメッセージ = this.APIアラートメッセージを取得(data);
    this.ダイアログを開く('アラート');
  }

  private APIアラートメッセージを取得(data: any): string[] {
    let メッセージ = [data.message];
    if (!data.errors) {
      return メッセージ;
    }
    for (const エラー of data.errors) {
      メッセージ = メッセージ.concat(['・' + エラー]);
    }
    return メッセージ;
  }

  private async 消費税取得ハンドラ(): Promise<void> {
    await progress(this.消費税取得);
  }

  private async 消費税取得(): Promise<void> {
    await api.譲渡確認消費税を取得する()
            .then((response: 譲渡確認消費税型) => {
              const 譲渡金額算出結果 = response;
              this.譲渡確認消費税 = 譲渡金額算出結果;
            }).catch((error: any) => {
              this.APIアラートダイアログを開く(error.data);
            });
  }

  private 消費税リスト() {
    const 消費税リスト: 譲渡確認消費税型[] = [];
    消費税リスト.push({消費税率: 0, 消費税パーセント表記: 'なし'});
    if (this.譲渡確認消費税) {
      消費税リスト.push(this.譲渡確認消費税);
    }
    return 消費税リスト;
  }

  private async 編集を破棄して譲渡検索を実行するハンドラ() {
    this.ダイアログを閉じる('編集中検索確認ダイアログ');
    await progress(this.譲渡検索)
            .then((response: any) => {
              viewEditingStateModule.画面の編集を終了する();
            }).catch((error: any) => {
              return;
            });
  }

  private async 譲渡検索ハンドラ() {
    if (this.検索条件バリデーション結果.hasErrors) {
      this.アラートメッセージ = this.検索条件バリデーション結果.getMessages();
      this.ダイアログを開く('アラート');
      return;
    }

    if (viewEditingStateModule.画面を編集中である) {
      this.ダイアログを開く('編集中検索確認ダイアログ');
      return;
    }

    await progress(this.譲渡検索)
            .then((response: any) => {
              viewEditingStateModule.画面の編集を終了する();
            }).catch((error: any) => {
              return;
            });
  }

  private async 譲渡検索(): Promise<void> {
    this.譲渡検索条件.部署コード = this.選択中譲渡先部署コード;
    await api.譲渡を検索する(this.譲渡検索条件)
            .then((response: 譲渡修正検索結果型) => {
              this.譲渡取込結果 = response.譲渡修正一覧;
              this.譲渡取込結果.forEach((譲渡修正) => {
                        譲渡修正.修正前譲渡 = this.修正前譲渡を作成する(譲渡修正);
                      },
              );
              if (this.譲渡取込結果.length === 0) {
                this.アラートメッセージ = '検索結果が0件です。';
                this.ダイアログを開く('アラート');
              }
              if (response.アラートメッセージ) {
                this.アラートメッセージ = response.アラートメッセージ;
                this.ダイアログを開く('アラート');
              }
            }).catch((error: any) => {
              this.APIアラートダイアログを開く(error.data);
              this.譲渡取込結果 = [];
            });
  }

  private 修正前譲渡を作成する(譲渡: 譲渡修正型): 修正前譲渡型 {
    return {
      ロット番号: 譲渡.ロット番号,
      譲渡数: 譲渡.譲渡数,
      譲渡単価: 譲渡.譲渡単価,
      消費税率: 譲渡.消費税率,
      有効期限: 譲渡.有効期限,
      手数料: 譲渡.手数料,
      備考: 譲渡.備考,
    };
  }

  private 行が修正されている(譲渡修正: 譲渡修正型): boolean {
    if (this.文字列フォーマット(譲渡修正.ロット番号) !== this.文字列フォーマット(譲渡修正.修正前譲渡.ロット番号)) return true;
    if (譲渡修正.譲渡数 !== 譲渡修正.修正前譲渡.譲渡数) return true;
    if (譲渡修正.譲渡単価 !== 譲渡修正.修正前譲渡.譲渡単価) return true;
    if (譲渡修正.消費税率 !== 譲渡修正.修正前譲渡.消費税率) return true;
    if (this.日付フォーマット(譲渡修正.有効期限) !== this.日付フォーマット(譲渡修正.修正前譲渡.有効期限)) return true;
    if (譲渡修正.手数料 !== 譲渡修正.修正前譲渡.手数料) return true;
    if (this.文字列フォーマット(譲渡修正.備考) !== this.文字列フォーマット(譲渡修正.修正前譲渡.備考)) return true;
    return false;
  }

  private 確定対象トグルボタンが無効である(譲渡修正: 譲渡修正型): boolean {
    return !this.行が修正されている(譲渡修正);
  }

  private 確定対象ボタンを制御する(行番号: number): void {
    const current = this.譲渡取込結果[行番号];
    if (this.行が修正されている(current)) {
      current.譲渡確定対象 = '対象';
      return;
    }
    current.譲渡確定対象 = '対象外';
  }

  private 日付フォーマット(date: 日付型): string | null {
    if (date === null) {
      return '';
    }
    return moment(date).format('YYYY/MM/DD');
  }

  private 文字列フォーマット(value: string) {
    if (!value) {
      return '';
    }
    return value;
  }

  private エラー判定(行番号: number, 項目名: string) {
    return {'input-error': this.譲渡修正バリデーション結果.hasError(項目名, 行番号)};
  }

  private 数値入力エラー判定(行番号: number, 項目名: string): boolean {
    return this.譲渡修正バリデーション結果.hasError(項目名, 行番号);
  }

  private 譲渡の削除を確認する(選択譲渡: 譲渡修正型) {
    this.譲渡削除対象 = 選択譲渡;
    this.ダイアログを開く('削除ダイアログ');
  }

  private async 譲渡を削除するハンドラ() {
    this.ダイアログを閉じる('削除ダイアログ');
    await progress(this.譲渡を削除する)
            .then((response: any) => {
              viewEditingStateModule.画面の編集を終了する();
            }).catch((error: any) => {
              return;
            });
  }

  private async 譲渡を削除する(): Promise<void> {
    if (this.譲渡削除対象 === null) {
      this.アラートメッセージ = '削除対象が選択されていません';
      this.ダイアログを開く('アラート');
      return;
    }

    const 譲渡削除依頼: 譲渡削除依頼型 = {譲渡SEQ: this.譲渡削除対象.譲渡SEQ, 更新バージョン: this.譲渡削除対象.更新バージョン};
    await api.譲渡を削除する(譲渡削除依頼)
            .then((response: any) => {
              this.譲渡取込結果 = this.譲渡取込結果.filter((data) => data.譲渡SEQ !== 譲渡削除依頼.譲渡SEQ);
              this.譲渡削除対象 = null;
              this.譲渡金額算出対象 = null;
              this.選択中の行index = null;
            }).catch((error: any) => {
              this.APIアラートダイアログを開く(error.data);
            });
  }

  private 削除ダイアログを閉じる() {
    this.譲渡削除対象 = null;
    this.ダイアログを閉じる('削除ダイアログ');
  }

  private async 譲渡金額算出ハンドラ(譲渡修正: 譲渡修正型): Promise<void> {
    this.譲渡金額算出対象 = 譲渡修正;
    await progress(this.譲渡金額算出);
  }

  private async 譲渡金額算出(): Promise<void> {
    if (this.譲渡金額算出対象 === null) {
      return;
    }
    const 譲渡SEQ = this.譲渡金額算出対象.譲渡SEQ;
    const 譲渡金額算出依頼: 譲渡金額算出依頼型 = {
      商品コード: this.譲渡金額算出対象.商品コード,
      譲渡日付: this.譲渡金額算出対象.譲渡日付,
      譲渡単価: this.譲渡金額算出対象.譲渡単価,
      譲渡数: this.譲渡金額算出対象.譲渡数,
      消費税率: this.譲渡金額算出対象.消費税率,
    };
    await api.譲渡金額を算出する(譲渡金額算出依頼)
            .then((response: 譲渡金額算出結果型) => {
              const 譲渡金額算出結果 = response;
              this.譲渡取込結果.filter((譲渡候補) => 譲渡候補.譲渡SEQ === 譲渡SEQ).map(
                      (譲渡候補入力: 譲渡修正型) => {
                        譲渡候補入力.譲渡金額 = 譲渡金額算出結果.譲渡金額;
                      },
              );
              this.譲渡削除対象 = null;
              this.譲渡金額算出対象 = null;
              this.選択中の行index = null;
            }).catch((error: any) => {
              // TODO エラー内容を出力する方法が必要
              // ダイアログ出すとonBlurイベントが発生して無限ループとなるためダイアログは不可。
              // this.APIアラートダイアログを開く(error.data);
            });
  }

  private async 確定ハンドラ(): Promise<void> {
    const 確定対象一覧 = this.譲渡取込結果.filter((譲渡修正) => 譲渡修正.譲渡確定対象 === '対象');
    if (確定対象一覧.length < 1) {
      this.アラートメッセージ = '確定対象が存在しません';
      this.ダイアログを開く('アラート');
      return;
    }
    if (this.譲渡修正バリデーション結果.hasErrors) {
      this.アラートメッセージ = this.譲渡修正バリデーション結果.getMessages(true);
      this.ダイアログを開く('アラート');
      return;
    }
    await progress(this.修正確定)
            .then((response: any) => {
              viewEditingStateModule.画面の編集を終了する();
            }).catch((error: any) => {
              return;
            });
  }

  private async 修正確定(): Promise<void> {
    const 確定対象一覧 = this.譲渡取込結果.filter((譲渡修正) => 譲渡修正.譲渡確定対象 === '対象');
    const 譲渡修正依頼: 譲渡修正依頼型 = {譲渡修正一覧: 確定対象一覧, 譲渡先部署: this.譲渡先部署コード};
    await api.譲渡を修正する(譲渡修正依頼)
            .then((response: any) => {
              this.譲渡削除対象 = null;
              this.譲渡金額算出対象 = null;
              this.選択中の行index = null;
              this.譲渡検索()
                      .then((譲渡検索response: any) => {
                        viewEditingStateModule.画面の編集を終了する();
                      }).catch((譲渡検索error: any) => {
                        return;
                      });
            }).catch((error: any) => {
              this.APIアラートダイアログを開く(error.data);
            });
  }

  private アラートダイアログを開く(event: Event) {
    this.アラートメッセージ = event.toString().split(',');
    this.ダイアログを開く('アラート');
  }

  private 行が選択されている(index: number) {
    return this.選択中の行index === index;
  }

  private async リスト選択時の処理(index: number) {
    this.選択中の行index = index;
  }

  private 編集不可(譲渡修正: 譲渡修正型): boolean {
    return 譲渡修正.譲渡入力方法 === '有効期限検索';
  }
}
